import { InputTrigger, ShotType, FakeInput } from "./game";
import App from "../main";

export class DeliverySystem {
    public static deliveries: { [key: string]: Delivery };
    public static outcomeAnimations: { [key: string]: BallAnimation };

    public static setup(ballAnimationsData: any) {
        // console.log('Delivery debug: ', App.GetParam('deliveryDebug'));
        Delivery.USE_FAKE_INPUT = App.GetParam('deliveryDebug') === 'true';
        //DeliveryDebug.Mode(App.GetParam('deliveryDebug') === 'true');

        DeliverySystem.deliveries = {};
        DeliverySystem.outcomeAnimations = {};

        
        ballAnimationsData.bowlingAnimationData
            .filter(animation => animation.animationName.includes('_'))
            .forEach(element => {
                DeliverySystem.outcomeAnimations[element.animationName] = new BallAnimation(element.animationName, element.ballPositions, element.shadowPositions);
            }
            );

        ballAnimationsData.bowlingAnimationData
            .filter(animation => !animation.animationName.includes('_'))
            .forEach(element => {
                DeliverySystem.deliveries[element.animationName] = new Delivery(element);
            }
            );
    }

    public static getOutcomeBallAnimation(ballAnimationName: string) {
        return DeliverySystem.outcomeAnimations[ballAnimationName];
    }

    public static getDelivery(filter?: string) {
        //if (deliveryName != null) {
        if (filter) {
            var keys = Object.keys(DeliverySystem.deliveries).filter(x => x.includes(filter));
        } else {
            var keys = Object.keys(DeliverySystem.deliveries);
        }


        return DeliverySystem.deliveries[keys[Math.floor(keys.length * Math.random())]];
    }
}

export class Delivery {

    private static playBallAnimation: (ballAnimation: BallAnimation) => void;

    public static RegisterPlayBallAnimationCallBack(callback: (ballAnimation: BallAnimation) => void) {
        Delivery.playBallAnimation = callback;
    }

    private static PlayBallAnimation(ballAnimation: BallAnimation) {
        if (Delivery.playBallAnimation != null) {
            Delivery.playBallAnimation(ballAnimation);
        }
    }

    private static playBatsmanAnimation: (animationName: string) => void;

    public static RegisterPlayBatsmanAnimationCallBack(callback: (animationName: string) => void) {
        Delivery.playBatsmanAnimation = callback;
    }

    private static PlayBatsmanAnimation(animationName: string) {
        if (Delivery.playBatsmanAnimation != null) {
            Delivery.playBatsmanAnimation(animationName);
        }
    }

    private static sendOutcome: (outcome: number) => void;

    public static RegisterSendOutcomeCallBack(callback: (outcome: number) => void) {
        Delivery.sendOutcome = callback;
    }

    private static SendOutcome(outcome: number) {
        if (Delivery.sendOutcome != null)
            Delivery.sendOutcome(outcome);
    }

    public name: string;
    public bowlerType: BowlerType;
    public inputTrigger: InputTrigger;
    public ballAnimation: BallAnimation;

    public none: NegativeOutcomeData;
    public negativeInput: NegativeOutcomeData;
    public positiveInput: NegativeOutcomeData;

    public positiveOutcomes: PositiveOutcomeData;

    constructor(delivery: any) {
        this.name = delivery.animationName;
        this.ballAnimation = new BallAnimation(delivery.animationName, delivery.ballPositions, delivery.shadowPositions);

        this.inputTrigger = delivery.outcomeTriggers[0].correctInputTrigger;
        this.bowlerType = delivery.outcomeTriggers[0].bowlerTypEndle;

        this.none = new NegativeOutcomeData(delivery.outcomeTriggers[0].none);
        this.negativeInput = new NegativeOutcomeData(delivery.outcomeTriggers[0].negativeInput);
        this.positiveInput = new NegativeOutcomeData(delivery.outcomeTriggers[0].positiveInput);

        this.positiveOutcomes = new PositiveOutcomeData(delivery.outcomeTriggers[0].positiveOutcomes);
    }

    public static USE_FAKE_INPUT: boolean = true;
    public static FAKE_DELIVERY: string = "Pace-Short-Straight";
    public static FAKE_INPUT: FakeInput = 0;
    public static FAKE_SHOT_TYPE: ShotType = 0;

    public updateFakeInput(frame: number) {
        switch (Delivery.FAKE_INPUT) {
            case FakeInput.None:

                break;

            case FakeInput.Wrong:

                if (frame >= this.ballAnimation.positions.length / 2) {
                    this.updateInput(this.inputTrigger == 1 ? 0 : 1);
                }
                break;

            case FakeInput.Right:
                switch (Delivery.FAKE_SHOT_TYPE) {
                    case ShotType.Early:
                        if (frame == (this.positiveOutcomes.positivePlayerSequences[0].getMinFrame()) - 5) {
                            this.updateInput(this.inputTrigger);
                        }
                        break;

                    case ShotType.EarlyShot:
                        if (frame > this.positiveOutcomes.positivePlayerSequences[0].getMinFrame() && frame < this.positiveOutcomes.positivePlayerSequences[0].getMaxFrame()) {
                            this.updateInput(this.inputTrigger);
                        }
                        break;

                    case ShotType.PerfectShot:
                        if (frame > this.positiveOutcomes.positivePlayerSequences[1].getMinFrame() && frame < this.positiveOutcomes.positivePlayerSequences[1].getMaxFrame()) {
                            this.updateInput(this.inputTrigger);
                        }
                        break;

                    case ShotType.LateShot:
                        if (frame > this.positiveOutcomes.positivePlayerSequences[2].getMinFrame() && frame < this.positiveOutcomes.positivePlayerSequences[2].getMaxFrame()) {
                            this.updateInput(this.inputTrigger);
                        }
                        break;

                    case ShotType.Late:
                        if (frame > this.positiveOutcomes.positivePlayerSequences[2].getMaxFrame() + 2) {
                            this.updateInput(this.inputTrigger);
                        }
                        break;
                }
        }
    }

    private currentFrame: number;
    private isWrongInputTrigger: boolean;

    public getPerfectShotFrame (): number {
        return this.positiveOutcomes.positivePlayerSequences[1].getMaxFrame() - 1;
    }

    public updateFrame(frame: number) {
        if (Delivery.USE_FAKE_INPUT) {
            this.updateFakeInput(frame);
        }

        if (frame < this.currentFrame || this.isDone) {
            return;
        }

        this.currentFrame = frame;

        if (this.currentInputTrigger == InputTrigger.None) {

            if (this.currentNegativeSequence) {
                //No input has given
                for (let i = 0; i < this.currentNegativeSequence.playerAnimations.length; i++) {

                    if (this.currentFrame == this.currentNegativeSequence.playerAnimations[i].triggerFrame) {
                        // Play player animation
                        // Play ball animation -> 
                        this.isDone = true; // if ball animation has been changed, terminate the 

                        var hasSendOutcome = false;
                        var playerAnimation = this.currentNegativeSequence.playerAnimations[0].playerAnimation;
                        Delivery.PlayBatsmanAnimation(playerAnimation);

                        hasSendOutcome = this.checkByPlayerAnimation(playerAnimation);

                        if (this.currentNegativeSequence.playerAnimations[0].hasBallAnimations()) {
                            var ballAnimation = this.currentNegativeSequence.playerAnimations[0].ballAnimations[0];
                            Delivery.PlayBallAnimation(ballAnimation);
                            if (ballAnimation.name.includes('LBW') || ballAnimation.name.includes('Catch')) {
                                if (!hasSendOutcome)
                                    hasSendOutcome = this.checkByBallAnimation(ballAnimation.name);
                            }
                        } else {
                            if (!hasSendOutcome)
                                Delivery.SendOutcome(0);
                        }
                    }
                }
            }
        } else if (this.isWrongInputTrigger) {

            for (let i = 0; i < this.currentNegativeSequence.playerAnimations.length; i++) {

                if (this.currentFrame == this.currentNegativeSequence.playerAnimations[i].triggerFrame) {
                    // Play player animation
                    // Play ball animation -> 
                    this.isDone = true; // if ball animation has been changed, terminate the

                    var hasSendOutcome = false;

                    var playerAnimation = this.currentNegativeSequence.playerAnimations[1].playerAnimation;
                    Delivery.PlayBatsmanAnimation(playerAnimation);

                    hasSendOutcome = this.checkByPlayerAnimation(playerAnimation);

                    if (this.currentNegativeSequence.playerAnimations[1].hasBallAnimations()) {
                        var ballAnimation = this.currentNegativeSequence.playerAnimations[1].ballAnimations[0]
                        Delivery.PlayBallAnimation(ballAnimation);
                        if (ballAnimation.name.includes('LBW') || ballAnimation.name.includes('Catch')) {
                            if (!hasSendOutcome)
                                hasSendOutcome = this.checkByBallAnimation(ballAnimation.name);
                        }
                    } else {
                        if (!hasSendOutcome)
                            Delivery.SendOutcome(OutcomeName.None);
                    }
                }
            }
        }
    }

    private checkByBallAnimation(animationName: string): boolean {
        // console.log(animationName);
        if (animationName.includes('LBW')) {
            Delivery.SendOutcome(OutcomeName.LBW);
            return true;
        } else if (animationName.includes('Catch')) {
            // console.log('Catch');
            Delivery.SendOutcome(OutcomeName.Catch);
            return true;
        }

        return false;
    }

    private checkByPlayerAnimation(animationName: string): boolean {
        if (animationName.includes('Hit')) {
            Delivery.SendOutcome(OutcomeName.None);
            return true;
        } else if (animationName.includes('Stumps')) {
            Delivery.SendOutcome(OutcomeName.Stumps);
            return true;
        }
        return false;
    }

    private currentInputTrigger: InputTrigger;
    private inputFrame: number;
    private currentNegativeSequence: NegativeSequence;

    private isDone: boolean;

    public updateInput(inputTrigger: InputTrigger) {
        if (this.currentInputTrigger != InputTrigger.None || this.isDone) {
            return;
        }

        this.currentInputTrigger = inputTrigger;
        this.inputFrame = this.currentFrame; // record the frame the input has given.
        // Assign an outcome
        if (this.currentInputTrigger != this.inputTrigger) {
            this.isWrongInputTrigger = true;
            // Wrong input given
            this.currentNegativeSequence = this.negativeInput.getRandomSequence(this.currentFrame);

            // Play the first animation
            Delivery.PlayBatsmanAnimation(this.currentNegativeSequence.playerAnimations[0].playerAnimation);


        } else if (this.currentInputTrigger == this.inputTrigger) {

            // Correct input given
            if (this.positiveOutcomes.isInPositiveOutcome(this.currentFrame)) {
                // Play a positive out come and stop
                this.isDone = true;
                var playerAnimation = this.positiveOutcomes.getPositivePlayerAnimation(this.currentFrame);
                Delivery.PlayBatsmanAnimation(playerAnimation.playerAnimation);
                var outcomeIndex = Math.floor(Math.random() * playerAnimation.scores.length);

                Delivery.PlayBallAnimation(playerAnimation.ballAnimations[outcomeIndex]);
                if (playerAnimation.scores[outcomeIndex] == -1) {
                    this.checkByBallAnimation(playerAnimation.ballAnimations[outcomeIndex].name);
                } else {
                    Delivery.SendOutcome(playerAnimation.scores[outcomeIndex]); // Send the score
                }


            } else {
                this.isWrongInputTrigger = true;

                // Postive input on wrong timing, lol
                this.currentNegativeSequence = this.positiveInput.getRandomSequence(this.currentFrame);

                //Delivery.SendOutcome (playerAnimation.scores[outcomeIndex]); // Send the score
                // Play the first animation
                Delivery.PlayBatsmanAnimation(this.currentNegativeSequence.playerAnimations[0].playerAnimation);
            }
        }

    }

    public resetFrame() {
        this.currentFrame = 0;
        this.currentInputTrigger = InputTrigger.None;
        this.isWrongInputTrigger = false;

        this.inputFrame = 0;
        this.isDone = false;
        this.currentNegativeSequence = this.none.getRandomSequence(this.currentFrame);
    }

}

export class BallAnimation {
    public name: string;
    public positions: Position[];
    public shadowPositions: Position[];

    constructor(name: string, ballPositions: any, shadowPositions: any) {
        this.name = name;
        this.positions = new Array(ballPositions.length);
        this.shadowPositions = new Array(ballPositions.length);

        for (let i = 0; i < ballPositions.length; i++) {
            this.positions[i] = new Position(
                ballPositions[i].x,
                ballPositions[i].y,
                ballPositions[i].scale
            );

            this.shadowPositions[i] = new Position(
                shadowPositions[i].x,
                shadowPositions[i].y,
                shadowPositions[i].scale
            );
        }
    }
}

export class Position {
    public x: number;
    public y: number;
    public z: number;

    constructor(x: number, y: number, z: number) {
        this.x = x;
        this.y = y;
        this.z = z;
    }
}

export class NegativeOutcomeData {
    public playerSequences: NegativeSequence[];

    constructor(none: any) {
        this.playerSequences = new Array(none.playerSequences.length);

        for (let i = 0; i < none.playerSequences.length; i++) {
            this.playerSequences[i] = new NegativeSequence(none.playerSequences[i]);
        }
    }

    public getRandomSequence(currentFrame: number): NegativeSequence {
        if (this.playerSequences.length == 1) {
            return this.playerSequences[0];
        }
        var filtered = this.playerSequences.filter(sequence => sequence.isWithinCurrentFrame(currentFrame));
        if (filtered.length < 1) {
            return this.playerSequences[Math.floor(Math.random() * this.playerSequences.length)];
        }
        return filtered[Math.floor(Math.random() * filtered.length)];
    }
}

export class NegativeSequence {
    public playerAnimations: NegativePlayerAnimation[];

    constructor(playerSequence: any) {
        this.playerAnimations = new Array(playerSequence.playerAnimations.length);

        for (let i = 0; i < playerSequence.playerAnimations.length; i++) {
            this.playerAnimations[i] = new NegativePlayerAnimation(playerSequence.playerAnimations[i]);
        }
    }

    public isWithinCurrentFrame(currentFrame: number): boolean {
        for (let i = 0; i < this.playerAnimations.length; i++) {
            if (this.playerAnimations[i].triggerFrame > currentFrame && this.playerAnimations[i].triggerFrame != -1)
                return true;

        }
        return false;
    }
}

export class NegativePlayerAnimation {
    public playerAnimation: string;
    public triggerFrame = -1;
    public ballAnimations: BallAnimation[];

    constructor(negativePlayerAnimation: any) {
        this.playerAnimation = negativePlayerAnimation.playerAnimation;
        this.triggerFrame = negativePlayerAnimation.triggerFrame;
        this.ballAnimations = new Array(negativePlayerAnimation.ballAnimations.length);

        for (let i = 0; i < negativePlayerAnimation.ballAnimations.length; i++) {
            this.ballAnimations[i] = DeliverySystem.getOutcomeBallAnimation(negativePlayerAnimation.ballAnimations[i]);
        }
    }

    public hasBallAnimations(): boolean {
        return this.ballAnimations.length > 0;
    }
}

export class PositiveOutcomeData {
    public positivePlayerSequences: PositivePlayerSequence[];

    constructor(positiveOutcomes: any) {

        this.positivePlayerSequences = new Array(positiveOutcomes.positiveSequence.length);

        for (let i = 0; i < positiveOutcomes.positiveSequence.length; i++) {
            this.positivePlayerSequences[i] = new PositivePlayerSequence(positiveOutcomes.positiveSequence[i]);
        }
    }

    public isInPositiveOutcome(frame: number): boolean {
        var filter = this.positivePlayerSequences.filter(playerSequence => playerSequence.isInPositiveOutcome(frame));
        return filter.length > 0;

    }

    public getPositivePlayerAnimation(frame: number): PositivePlayerAnimation {
        var filteredSequences = this.positivePlayerSequences.filter(playerSequence => playerSequence.isInPositiveOutcome(frame));
        return filteredSequences[0].getPositiveAnimation(frame);
    }

    public getFakeTriggerFrame(fakeInputType: Delivery.FAKE_SHOT_TYPE) {

    }
}

export class PositivePlayerSequence {
    public positivePlayerAnimations: PositivePlayerAnimation[];

    constructor(positivePlayerSequence: any) {

        this.positivePlayerAnimations = new Array(positivePlayerSequence.positiveAnimations.length);

        for (let i = 0; i < positivePlayerSequence.positiveAnimations.length; i++) {
            this.positivePlayerAnimations[i] = new PositivePlayerAnimation(positivePlayerSequence.positiveAnimations[i]);
        }
    }

    public isInPositiveOutcome(frame: number): boolean {
        var filtered = this.positivePlayerAnimations.filter(playerAnimation => playerAnimation.isInPositiveOutcome(frame));
        return filtered.length > 0;
    }



    public getPositiveAnimation(frame: number): PositivePlayerAnimation {
        var filtered = this.positivePlayerAnimations.filter(playerAnimation => playerAnimation.isInPositiveOutcome(frame));
        var outcomeIndex = Math.floor(Math.random() * filtered.length);
        return filtered[outcomeIndex];
    }

    public getMinFrame(): number {
        return Math.min.apply(Math, this.positivePlayerAnimations.map(function (o) {
            return o.minFrame;
        }));
    }

    public getMaxFrame(): number {
        return Math.max.apply(Math, this.positivePlayerAnimations.map(function (o) {
            return o.maxFrame;
        }));
    }
}

export class PositivePlayerAnimation {
    public playerAnimation: string;
    public minFrame: number;
    public maxFrame: number;

    public scores: number[];
    public ballAnimations: BallAnimation[];

    constructor(playerAnimation: any) {
        this.playerAnimation = playerAnimation.playerAnimation;
        this.minFrame = playerAnimation.minFrame;
        this.maxFrame = playerAnimation.maxFrame;

        this.scores = playerAnimation.scores.split(',');
        this.scores.forEach((x, index) => { this.scores[index] = parseInt(x) });

        this.ballAnimations = new Array(playerAnimation.ballAnimations.length);

        for (let i = 0; i < playerAnimation.ballAnimations.length; i++) {
            this.ballAnimations[i] = DeliverySystem.getOutcomeBallAnimation(playerAnimation.ballAnimations[i]);
        }
    }

    public isInPositiveOutcome(frame: number): boolean {
        return frame >= this.minFrame && frame <= this.maxFrame;
    }
}

enum BowlerType { Spin = 0, Straight = 1, Swing = 2 }

export enum OutcomeName { None = 0, One = 1, Two = 2, Three = 3, Four = 4, Six = 6, Stumps = -1, LBW = -2, Catch = -3 }


